import ApplicationController from '../application_controller'
//import { get_csrf_token } from '../../app/csrf_token.js'

export default class extends ApplicationController {

	static targets = [
		'selectFilesButton',
		'inputFiles',
		'listFiles',
		'fileCount',
		'actionsSection',
		'artifactTypeInstructions',
	]

	static values = {
		artifactTypes: Array // Array should consist only of [value, label] tuples
	}

	connect() {
	}

	startFileSelect() {
		this.inputFilesTarget.click()
	}

	filesChanged(event) {
		this.files = event.target.files
		this.updateSelectFilesButton()
		this.updateFileCount()
		this.updateListFiles()
		this.updateArtifactTypeInstructions()
		this.updateActionsSection()
	}

	updateSelectFilesButton() {
		if (!this.files || this.files.length == 0) {
			this.selectFilesButtonTarget.classList.remove('d-none')
			return
		}

		this.selectFilesButtonTarget.classList.add('d-none')
	}

	updateFileCount() {
		if (!this.hasFileCountTarget) return

		if (!this.files || this.files.length == 0) {
			this.fileCountTarget.innerHTML = `0 Files Selected`
			return
		}
		
		if (this.files.length == 1) { 
			this.fileCountTarget.innerHTML = `1 File Selected`
			return
		}

		this.fileCountTarget.innerHTML = `${this.files.length} Files Selected`
	}

	updateListFiles() {
		if (!this.files || !this.files.length) {
			this.listFilesTarget.classList.add('d-none')
			this.listFilesTarget.innerHTML = ""
			return
		}
		
		this.listFilesTarget.classList.remove('d-none')
		let listHTML = ""
		for (const file of this.files) {
			listHTML += `
<li class='list-group-item'>
	<div class='d-flex flex-column flex-md-row justify-content-between align-items-center'>
		<div class='display-11 flex-grow-1'>${file.name}</div>
		<div class='flex-shrink-1'>
			<div class='input-group'><div class='input-group-text'>Artifact Type</div>${this.getArtifactTypeSelect()}</div>
		</div>
	</div>
</li>`
		}
		this.listFilesTarget.innerHTML = listHTML
	}

	getArtifactTypeSelect() {
		const optionElements = []
		for(const [value, label] of this.artifactTypesValue) {
			optionElements.push(`<option value='${value}'>${label}</option>`)
		}
		return `<select name='artifacts[artifact_types][]' class='form-select' autocomplete='off'>${optionElements.join('')}</select>`
	}

	updateActionsSection() {
		if (!this.hasActionsSectionTarget) return

		if (!this.files || this.files.length == 0) {
			this.actionsSectionTarget.classList.add('d-none')
			return
		}

		this.actionsSectionTarget.classList.remove('d-none')
	}

	updateArtifactTypeInstructions() {
		if (!this.hasArtifactTypeInstructionsTarget) return

		if (!this.files || this.files.length == 0) {
			this.artifactTypeInstructionsTarget.classList.add('d-none')
			return
		}

		this.artifactTypeInstructionsTarget.classList.remove('d-none')
	}

	resetFileSelect(event) {
		this.inputFilesTarget.value = ""
		this.files = this.inputFilesTarget.files
		this.updateSelectFilesButton()
		this.updateFileCount()
		this.updateListFiles()
		this.updateArtifactTypeInstructions()
		this.updateActionsSection()
	}

}
